import { IdScanComplete } from '@verifime/components';
import { useScanContext } from './ScanContext';
import { Box } from '@mui/material';

export default function IdScanCompleteView() {
  const {
    state: { scanStatus },
  } = useScanContext();

  if (scanStatus !== 'SUCCEEDED') {
    return null;
  }

  return (
    <Box data-component="IdScanCompleteView">
      <IdScanComplete />
    </Box>
  );
}
